<template>
    <div class="container">
        <div class="center">
            <div class="headline">
                <h1>นิทานสำหรับเด็ก</h1>
                <h3>I’mCorona</h3>
            </div>
            <div class="panal">
                <b-container>
                    <b-row>
                        <b-col>
                            <a href="https://online.pubhtml5.com/gflw/kvao/" target="_blank">
                                <b-img class="img-icon" v-bind="mainProps" :src="require(`@/assets/ebook.png`)"></b-img>
                            </a>
                            <h4>EBook</h4>
                        </b-col>
                        <b-col>
                            <a href="static/corona_pdf.pdf" target="_blank">
                            <b-img class="img-icon" v-bind="mainProps" :src="require(`@/assets/pdf.png`)"></b-img>
                            </a>
                            <h4>PDF</h4>
                        </b-col>
                    </b-row>
                </b-container>
            </div>
        </div>
        <div class="right-bottom">
            <b-img height="120" :src="require(`@/assets/credit.png`)"></b-img>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Ebook",
        data() {
            return {
                mainProps: {blankColor: '#777', height: 80, class: 'm1'},
            }
        }
    }
</script>

<style scoped>
    h4 {
        margin-top: 10px;
        font-weight: bold;
    }

    h6 {
        margin-top: -5px;
    }
    .img-icon {
        background-color: white;
        border-radius: 10px;
        margin-top: 10px;
    }
    .container {
        height: 100%;
        position: relative;
    }

    .center {
        padding: 10px;
        position: absolute;
        top: 50%;
        width: 90%;
        -ms-transform: translate(0%, -60%);
        transform: translate(0%, -60%);
    }

    .panal {
        background-color: rgba(255, 255, 255, 0.5);
        border-radius: 10px;
        margin-top: 15px;
    }

    .headline {
        color: white;
    }

    .right-bottom {
        text-align: right;
        position: absolute;
        bottom: -10px;
        right: 0px;
    }
</style>